import { usageCollection } from '@/db/firestore';
import { UsageModel } from '@/models/usage';

export class Usage {
    public addUsage(event: UsageModel) {
        return usageCollection.add(event);
    }
}